<template>
  <div class="card-list-contain">
    <Empty
      v-if="netError || isListEmpty"
      class="empty"
      :show-buy-btn="showBuyBtn"
      :show-all="showAll"
      @reload="reload"
    />
    <div
      v-else
      ref="divScroll"
      :class="[isHelloFamilyApp === true ? 'order-list' : 'order-list-h5']"
      @scroll="onScroll"
    >
      <van-list
        v-model="loading"
        class="order-list-wrapper"
        :finished="!orderState.hasMore"
        finished-text="没有更多了"
        :immediate-check="false"
        @load="onLoad"
      >
        <div
          v-for="item in orderState.orderList"
          :key="item.orderId"
          class="order-cell-wrapper"
        >
          <OrderCell
            class="order-cell"
            :order="item"
            @reload="reload"
          />
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
import { mapState, mapActions } from 'vuex';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { appQueryConfig } from '~mall/common/utils/url';
import OrderCell from './OrderCell.vue';
import Empty from '~mall/components/NoTicket.vue';
import { isHelloFamilyApp } from '~mall/common/env/env';

export default {
  name: 'OrderList',
  components: {
    OrderCell,
    Empty,
  },
  props: {
    showAll: {
      type: Boolean,
      default: true,
    },
  },
  inject: ['styleVersion'],
  data() {
    return {
      loading: true,
      netError: false,
      scrollTop: 0,
      showBuyBtn: !appQueryConfig.activityId,
    };
  },
  computed: {
    ...mapState('order', {
      orderStateOrig: (state) => state,
    }),
    isListEmpty() {
      return !this.loading
          && Array.isArray(this.orderState.orderList)
          && this.orderState.orderList.length === 0;
    },
    orderState() {
      if (this.showAll === true) {
        return this.orderStateOrig.allOrderList;
      }
      return this.orderStateOrig.effectiveOrderList;
    },
    isHelloFamilyApp() {
      return isHelloFamilyApp;
    },
    activityId() {
      /** 优先使用链接上的activityId——应用内部跳转 */
      return this.$route.query.activityId || appQueryConfig.activityId;
    },
    sceneCode() {
      return this.$route.query.scene_code || appQueryConfig.scene_code;
    },
    subSceneCode() {
      return this.$route.query.sub_scene_code || appQueryConfig.sub_scene_code;
    },
    contentId() {
      if (this.showAll === true) {
        return 'platform_allOrder';
      }
      return 'platform_inEffectTab';
    },
  },
  mounted() {
    this.reload();
    UBT.pageView({
      pageId: 'platform_couponMall_orderList',
      categoryId: 'platform',
      businessInfo: {
        experimentalGroup: this.styleVersion,
      },
    });
  },
  beforeDestroy() {
    UBT.pageViewOut({
      pageId: 'platform_couponMall_orderList',
      categoryId: 'platform',
      businessInfo: {
        experimentalGroup: this.styleVersion,
      },
    });
  },
  methods: {
    ...mapActions('order', {
      actionRequestBuyList: 'actionRequestBuyList',
    }),
    onScroll(event) {
      const { scrollTop } = event.target;
      this.scrollTop = scrollTop;
    },
    handleScroll(toTop) {
      if (this.$refs.divScroll) {
        this.$refs.divScroll.scrollTop = toTop;
      }
    },
    async reload() {
      try {
        Toast.loading({
          message: '加载中...',
          duration: 0,
        });
        this.loading = true;
        this.netError = false;
        let showStatus = 'all';
        if (this.showAll === false) {
          showStatus = 'effective';
        }
        // 新订单列表过滤掉已关闭的订单
        await this.actionRequestBuyList({
          pageNum: 1,
          activityId: this.activityId,
          showStatus,
          sceneCode: this.sceneCode,
          subSceneCode: this.subSceneCode,
          filterClosedOrder: true,
        });
        Toast.clear();
      } catch (e) {
        this.netError = true;
      } finally {
        this.loading = false;
      }
    },
    async onLoad() {
      try {
        this.loading = true;
        let showStatus = 'all';
        if (this.showAll === false) {
          // 显示生效中
          showStatus = 'effective';
        }
        await this.actionRequestBuyList({
          pageNum: this.orderState.curPage + 1,
          activityId: this.activityId,
          showStatus,
          sceneCode: this.sceneCode,
          subSceneCode: this.subSceneCode,
          // 过滤已关闭订单
          filterClosedOrder: true,
        });
      } catch (e) {
        this.netError = true;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

  <style lang="less" scoped>
    .card-list-contain {
      height: 100%;

      .order-list {
        min-height: 100vh;
        box-sizing: border-box;

        .order-list-wrapper {
          padding: 0 0.12rem;
          display: flex;
          flex-direction: column;
        }
      }

      .order-list-h5 {
        min-height: 100vh;
        padding-top: 8px;
        box-sizing: border-box;

        .order-list-wrapper {
          padding: 0 0.12rem;
          display: flex;
          flex-direction: column;
        }
      }

      .empty {
        margin-top: 164px;
      }
    }
  </style>
